import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class BlockCategorizedContent {
    constructor() {
        BlockCategorizedContent.dynamicCategoriesCursor()
        BlockCategorizedContent.categoriesClickActions()
        BlockCategorizedContent.mobileSelect()
        BlockCategorizedContent.dynamicLayoutSlider()
        BlockCategorizedContent.dynamicLayoutGrid()
        BlockCategorizedContent.sliderItems()
    }

    //For slider and grid
    static categoriesClickActions() {
        const bloc = $('.wp-block-customer-categorized-content')

        if (bloc.length > 0) {
            const categories = '[data-element="categorized-content-categories"]'

            $(categories).each(function () {
                const category = $(this).find('[data-element="categorized-content-category"]')

                $(this)
                    .find('[data-element="categorized-content-category"]')
                    .first()
                    .addClass('active')

                $(category).on('click', function (e) {
                    e.preventDefault()

                    if ($(this).hasClass('active')) {
                        if ($(this).attr('data-target').length > 0) {
                            location.href = $(this).attr('data-target')
                        }
                    }

                    $(category).removeClass('active')
                    $(this).addClass('active')
                })
            })
        }
    }

    //For slider
    static dynamicCategoriesCursor() {
        const blocSlider = $('.wp-block-customer-categorized-content__type-slider')

        if (blocSlider.length > 0) {
            const categories = blocSlider.find('[data-element="categorized-content-categories"]')

            $(categories).each(function () {
                const cursor = $(this).find('[data-element="categorized-content-cursor"]')
                const category = $(this).find('[data-element="categorized-content-category"]')

                $(category).hover(function () {
                    const category_top = $(this).position().top
                    $(cursor).css('top', category_top)
                })

                $(category).on('click', function () {
                    const category_top = $(this).position().top
                    $(cursor).css('top', category_top)
                })
            })
        }
    }

    //For slider
    static async sliderItems() {
        const blocSlider = $('.wp-block-customer-categorized-content__type-slider')
        const selector = blocSlider.find('[data-element="carousel-categorized-content"]')
        const trigger = blocSlider.find('[data-element="categorized-content-category"]')

        if ($(selector).length) {
            $(selector).each(async function () {
                const spaceBetween =
                    undefined !== $(this).attr('data-space-between')
                        ? Number.parseInt($(this).attr('data-space-between'))
                        : 20
                const spaceBetweenMedium =
                    undefined !== $(this).attr('data-space-between-medium')
                        ? Number.parseInt($(this).attr('data-space-between-medium'))
                        : 30
                const spaceBetweenLarge =
                    undefined !== $(this).attr('data-space-between-large')
                        ? Number.parseInt($(this).attr('data-space-between-large'))
                        : 40

                const slider_items = await Swiper.create(this, {
                    slidesPerView: 1,
                    mousewheel: {
                        forceToAxis: true,
                    },
                    speed: 600,
                    lazy: true,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: '.wp-block-customer-categorized-content__content__slider__nav',
                    },
                    spaceBetween: spaceBetween,
                    freeMode: {
                        enabled: true,
                        sticky: true,
                    },
                    grabCursor: true,
                    breakpoints: {
                        650: {
                            slidesPerView: 1,
                            spaceBetween: spaceBetweenMedium,
                        },
                        1150: {
                            slidesPerView: 2,
                            spaceBetween: spaceBetweenMedium,
                        },
                        1250: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1400: {
                            slidesPerView: 2,
                            spaceBetween: spaceBetweenLarge,
                        },
                    },
                })

                $(trigger).on('click', () => {
                    slider_items.slideTo(0, 600, false)
                    slider_items.update()
                })
            })
        }
    }

    //For slider
    static mobileSelect() {
        if (
            window.matchMedia('(max-width: 650px)').matches ||
            $('.wp-block-customer-categorized-content--eco').length > 0
        ) {
            const blocSlider = $('.wp-block-customer-categorized-content__type-slider')

            if (blocSlider.length > 0) {
                $(blocSlider).each(function () {
                    const trigger = $(this).find(
                        '[data-trigger="categorized-content-categories-select-mobile"]',
                    )
                    const list = $(this).find('[data-element="categorized-content-categories"]')
                    const more = $(this).find('[data-element="categorized-content-block-more"]')
                    const items = $(list).find('[data-element="categorized-content-category"]')

                    //Animation liste déroulante
                    $(trigger).on('click', () => {
                        $(list).toggleClass('select-active')
                        if (list.hasClass('select-active')) {
                            list.animate(
                                {
                                    height: list.get(0).scrollHeight,
                                },
                                50,
                                'linear',
                            )
                        } else {
                            list.animate(
                                {
                                    height: list.height(0),
                                },
                                50,
                                'linear',
                            )
                        }
                    })

                    //Selection
                    $(items).on('click', function () {
                        trigger.text($(this).text())
                        $(list).toggleClass('select-active')
                        list.animate(
                            {
                                height: list.height(0),
                            },
                            50,
                            'linear',
                        )

                        //Add more button
                        if ($(this).attr('data-target')) {
                            const href = $(this).attr('data-target')
                            more.html(
                                `<a href="${href}" class="advanced-link">${Customer.translate.customerMore}</a>`,
                            )
                        } else {
                            more.html('')
                        }
                    })

                    //Add more button init
                    items.each(function () {
                        if ($(this).hasClass('active') && $(this).attr('data-target')) {
                            const href = $(this).attr('data-target')
                            more.html(
                                `<a href="${href}" class="advanced-link">${Customer.translate.customerMore}</a>`,
                            )
                        }
                    })
                })
            }
        }
    }

    //For slider
    static dynamicLayoutSlider() {
        const blocSlider = $('.wp-block-customer-categorized-content__type-slider')

        if (blocSlider.length > 0) {
            $(blocSlider).each(function () {
                const $block = $(this)
                const items = $block.find('[data-element="categorized-content-item"]')
                const categories = $block.find('[data-element="categorized-content-categories"]')
                const init_item_category = $block
                    .find('[data-element="categorized-content-category"]')
                    .first()
                    .attr('data-slug')
                let items_count = $block.find(`[data-category="${init_item_category}"]`).length

                $(categories).each(function () {
                    const category = $(this).find('[data-element="categorized-content-category"]')

                    //Init display items
                    $(items).each(function () {
                        const item_category = $(this).attr('data-category')
                        if (item_category !== init_item_category) {
                            $(this).hide()
                        }
                    })

                    //On click display items
                    $(category).on('click', function () {
                        const category_selected = $(this).attr('data-slug')
                        items_count = $block.find(
                            `[data-category="${$(this).attr('data-slug')}"]`,
                        ).length

                        $(items).each(function () {
                            const item_category = $(this).attr('data-category')
                            if (item_category !== category_selected) {
                                $(this).hide()
                            } else {
                                $(this).show()
                            }
                        })
                    })
                })
            })
        }
    }

    //For grid
    static dynamicLayoutGrid() {
        const blocGrid = $('.wp-block-customer-categorized-content__type-grid')

        //Grid Layout
        const items_count_style = [
            {}, // No changes
            {}, // No changes
            { 'grid-template-columns': '1fr', 'grid-template-rows': 'repeat(2, calc(50% - 10px))' }, // 2 items
            {
                'grid-template-columns': 'repeat(2, 1fr)',
                'grid-template-rows': 'repeat(2, calc(50% - 10px))',
            }, // 3 items
            {
                'grid-template-columns': 'repeat(2, 1fr)',
                'grid-template-rows': 'repeat(2, calc(50% - 10px))',
            }, // 4 items
            {
                'grid-template-columns': 'repeat(2, 1fr)',
                'grid-template-rows': 'repeat(3, calc(100% / 3 - (40px / 3)))',
            }, // 5 items
            {
                'grid-template-columns': 'repeat(2, 1fr)',
                'grid-template-rows': 'repeat(3, calc(100% / 3 - (40px / 3)))',
            }, // 6 items
        ]

        if (blocGrid.length > 0) {
            $(blocGrid).each(function () {
                const $block = $(this)
                const layout = $block.find('[data-wrapper="categorized-content-items"]')
                const items = $block.find('[data-element="categorized-content-item"]')
                const categories = $block.find('[data-element="categorized-content-categories"]')
                const init_item_category = $block
                    .find('[data-element="categorized-content-category"]')
                    .first()
                    .attr('data-slug')
                let items_count = $block.find(`[data-category="${init_item_category}"]`).length

                //Init layout
                $(layout).css(items_count_style[items_count])
                if (items_count === 3 || items_count === 5) {
                    $(layout)
                        .find(items)
                        .first()
                        .addClass('wp-block-customer-categorized-content__content__item__large')
                }

                $(categories).each(function () {
                    const category = $(this).find('[data-element="categorized-content-category"]')

                    //Init display items
                    $(items).each(function () {
                        const item_category = $(this).attr('data-category')
                        if (item_category !== init_item_category) {
                            $(this).hide()
                        }
                    })

                    //On click display items
                    $(category).on('click', function () {
                        let firstchild_increment = true
                        const category_selected = $(this).attr('data-slug')
                        items_count = $block.find(
                            `[data-category="${$(this).attr('data-slug')}"]`,
                        ).length

                        $(layout).css(items_count_style[items_count])
                        $(items).each(function () {
                            const item_category = $(this).attr('data-category')
                            if (item_category !== category_selected) {
                                $(this).hide()
                            } else {
                                // First child large item (grid)
                                if (
                                    firstchild_increment === true &&
                                    items_count % 2 === 1 &&
                                    $(this).hasClass(
                                        'wp-block-customer-categorized-content__content__grid__item',
                                    )
                                ) {
                                    $(this).addClass(
                                        'wp-block-customer-categorized-content__content__item__large',
                                    )
                                    $(layout).prepend($(this))
                                    firstchild_increment = false
                                }

                                $(this).show()
                            }
                        })
                    })
                })
            })
        }
    }
}

new BlockCategorizedContent()
